import { render, staticRenderFns } from "./CosignerAlert.vue?vue&type=template&id=0184e72a&scoped=true&"
import script from "./CosignerAlert.vue?vue&type=script&lang=js&"
export * from "./CosignerAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0184e72a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0184e72a')) {
      api.createRecord('0184e72a', component.options)
    } else {
      api.reload('0184e72a', component.options)
    }
    module.hot.accept("./CosignerAlert.vue?vue&type=template&id=0184e72a&scoped=true&", function () {
      api.rerender('0184e72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/CosignerAlert.vue"
export default component.exports